module.exports = __webpack_public_path__ + "53a28ae515b5e4845c6892cda1959c25.jpg";